import { useEffect, useState } from "react";
import { THEME_CHANGE_EVENT, ThemeMode } from "@/helpers/theme";

const THEME_ATTRIBUTE = "data-theme";

const readThemeMode = (): ThemeMode => {
  if (typeof document === "undefined") {
    return "light";
  }
  return document.documentElement.getAttribute(THEME_ATTRIBUTE) === "dark"
    ? "dark"
    : "light";
};

const useThemeMode = (): ThemeMode => {
  const [themeMode, setThemeMode] = useState<ThemeMode>(readThemeMode);

  useEffect(() => {
    const root = document.documentElement;
    const syncThemeMode = () => setThemeMode(readThemeMode());

    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.attributeName === THEME_ATTRIBUTE) {
          syncThemeMode();
          break;
        }
      }
    });
    observer.observe(root, {
      attributes: true,
      attributeFilter: [THEME_ATTRIBUTE],
    });

    window.addEventListener(THEME_CHANGE_EVENT, syncThemeMode);
    return () => {
      observer.disconnect();
      window.removeEventListener(THEME_CHANGE_EVENT, syncThemeMode);
    };
  }, []);

  return themeMode;
};

export default useThemeMode;
